
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import {
    bankFinanceSettlepagelist,
    bankFinanceSettledetail,
    bankFinanceSettlesave
  } from "@/api/supplier"
	import Dialog from '@/components/dialog.vue';
  @Component({  
    name: '',
    components: {
      PageFooter,
			'slz-dialog': Dialog,
    }
  })

  export default class ProductList extends Vue {
    private keywords = ''
    private tablelist:any = []
    private tableloading = false
    private pageNo = 1
    private pageSize = 10
    private total = 0
    private rowmsg:any = {}
    private diaShow = false

    private mounted () {
      this.gettablelist()
    }



    private async confirm(){
      if(!this.rowmsg.BankName){
        this.$message.error('请输入银行名称')
        return
      }
      if(!this.rowmsg.BankCode){
        this.$message.error('请输入行号')
        return
      }
      try{
        let res = await bankFinanceSettlesave(this.rowmsg)
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.diaShow = false
          this.gettablelist()
        }
      }finally{
        //
      }
    }
    private async edit(row){
      this.diaShow = true
      if(row.Id){
        try{
          let res = await bankFinanceSettledetail({Id:await row.Id})
          if(res.IsSuccess){
            this.rowmsg = res.Result
          }
        }finally{
          //
        }
      }else{
        this.rowmsg = {
          Id:0,
          BankName:'',
          BankCode:''
        }
      }
    }
    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    } 
    private clearSearch(){
      this.keywords = ''
      this.doSearch()
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let res = await bankFinanceSettlepagelist({
          Keywords:this.keywords,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        })
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
  }
